import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  Descriptions,
  Spin,
  Image,
  Input,
  Button,
  Form,
  Select,
  DatePicker,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../store";
import {
  detailAttendanceRequest,
  updateAttendanceRequest,
} from "../slices/attendance";
import { getScheduleRequest } from "../slices/schedule";
import { getBranchRequest } from "../slices/branch";
import moment from "moment";

const DetailAttendance: React.FC = () => {
  // const { id } = useParams<{ id: string }>();
  // const [form] = Form.useForm();
  // const dispatch = useDispatch();

  // console.log("ID", id);

  // const { detail, loading, scheduleList, branchLists, update } =
  //   useTypedSelector((state) => ({
  //     detail: state.Attendance.detail,
  //     loading: state.Attendance.pageIsLoading,
  //     scheduleList: state.Schedule.scheduleList,
  //     branchLists: state.Branch.branchList,
  //     update: state.Attendance.update,
  //   }));

  // const [editableData, setEditableData] = useState<any>(null);

  // // useEffect(() => {
  // //   if (id) {
  // //     dispatch(detailAttendanceRequest(id as any) as any);
  // //     dispatch(getScheduleRequest() as any);
  // //     dispatch(getBranchRequest() as any);
  // //   }
  // // }, []);

  // // useEffect(() => {
  // //   dispatch(detailAttendanceRequest(id as any) as any);
  // //   dispatch(getScheduleRequest() as any);
  // //   dispatch(getBranchRequest() as any);
  // // }, [update, dispatch]);

  // // useEffect(() => {
  // //   if (detail) {
  // //     setEditableData(detail);
  // //     form.setFieldsValue(detail); // Set nilai default di form
  // //   }
  // // }, [detail]);

  // // useEffect(() => {
  // //   if (detail) {
  // //     setEditableData(detail);
  // //   }
  // // }, [detail]);

  // useEffect(() => {
  //   if (id) {
  //     dispatch(detailAttendanceRequest(id as any) as any);
  //     dispatch(getScheduleRequest() as any);
  //     dispatch(getBranchRequest() as any);
  //   }
  // }, [id, dispatch]); // Hanya dijalankan saat id berubah

  // useEffect(() => {
  //   if (update) {
  //     dispatch(detailAttendanceRequest(id as any) as any);
  //   }
  // }, [update, id, dispatch]); // Hanya dijalankan saat update berubah

  // useEffect(() => {
  //   if (detail) {
  //     setEditableData(detail);
  //     form.setFieldsValue(detail); // Set nilai default di form
  //   }
  // }, [detail, form]); // Hanya dijalankan saat detail berubah

  // const handleChange = (key: string, value: any) => {
  //   setEditableData((prev: any) => ({
  //     ...prev,
  //     [key]: value,
  //   }));
  // };

  // const handleSave = () => {
  //   const changedFields: any = {};

  //   // Iterasi melalui setiap field di editableData dan bandingkan dengan detail untuk mendeteksi perubahan
  //   Object.keys(editableData).forEach((key) => {
  //     if (editableData[key] !== detail[key]) {
  //       changedFields[key] = editableData[key];
  //     }
  //   });

  //   // Hanya kirim id dan field yang berubah
  //   if (Object.keys(changedFields).length > 0) {
  //     const dataToUpdate = { id, ...changedFields };
  //     console.log("Data yang akan dikirim:", dataToUpdate);

  //     dispatch(updateAttendanceRequest(dataToUpdate) as any); // Gantilah dengan dispatch untuk update
  //   } else {
  //     console.log("Tidak ada perubahan.");
  //   }
  // };

  // if (loading) {
  //   return <Spin size="large" />;
  // }

  // // if (!detail) {
  // //   return <p>Data tidak ditemukan.</p>;
  // // }

  // console.log("SCD", scheduleList);
  // console.log("ET", detail);

  // const [scheduleCode, scheduleTime] = detail.schedule.split("-");
  // const scheduleTimes = scheduleTime
  //   ? scheduleTime.trim().slice(1, -1).split("-")
  //   : ["off", "off"];

  // const defaultTimeIn = scheduleTimes[0]; // e.g. "13:00:00"
  // const defaultTimeOut = scheduleTimes[1]; // e.g. "21:00:00"

  // // Find the schedule object based on the parsed scheduleCode
  // console.log("CD", scheduleCode);

  // const defaultSchedule = scheduleList.find(
  //   (schedule) => schedule.code === scheduleCode
  // );

  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { detail, loading, scheduleList, branchLists, update } =
    useTypedSelector((state) => ({
      detail: state.Attendance.detail,
      loading: state.Attendance.pageIsLoading,
      scheduleList: state.Schedule.scheduleList,
      branchLists: state.Branch.branchList,
      update: state.Attendance.update,
    }));

  const [editableData, setEditableData] = useState<any>(null);

  useEffect(() => {
    if (id) {
      dispatch(detailAttendanceRequest(id as any) as any);
      dispatch(getScheduleRequest() as any);
      dispatch(getBranchRequest() as any);
    }
  }, [id, dispatch]); // Menambahkan id agar dependensi tetap valid

  useEffect(() => {
    if (id) {
      dispatch(detailAttendanceRequest(id as any) as any);
    }
  }, [update, dispatch, id]); // Menjalankan kembali saat update berubah

  useEffect(() => {
    if (detail) {
      setEditableData(detail);
      form.setFieldsValue(detail); // Set nilai default di form
    }
  }, [detail, form]); // Menambahkan form agar tetap up-to-date

  useEffect(() => {
    console.log("Data attendance telah diperbarui:", detail);
  }, [detail]);

  const handleChange = (key: string, value: any) => {
    setEditableData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = () => {
    if (!editableData) return;

    const changedFields: any = {};
    Object.keys(editableData).forEach((key) => {
      if (editableData[key] !== detail?.[key]) {
        changedFields[key] = editableData[key];
      }
    });

    if (Object.keys(changedFields).length > 0) {
      dispatch(updateAttendanceRequest({ id, ...changedFields }) as any);
    }
  };

  if (loading) {
    return <Spin size="large" />;
  }

  if (!detail) {
    return <p>Data tidak ditemukan.</p>;
  }

  // **Mencegah error karena `detail.schedule` bisa undefined/null**
  const scheduleString = detail.schedule || "- (-)"; // Default jika `schedule` tidak ada
  const [scheduleCode, scheduleTime] = scheduleString.split("-");
  const scheduleTimes = scheduleTime
    ? scheduleTime.trim().slice(1, -1).split("-")
    : ["off", "off"];

  const defaultSchedule = scheduleList.find(
    (schedule) => schedule.code === scheduleCode.trim()
  );

  return (
    <>
      {detail && scheduleList && editableData ? (
        <Card
          title="Detail Attendance"
          style={{ maxWidth: 800, margin: "20px auto" }}
        >
          <Form form={form} layout="vertical">
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Nama">
                <Input
                  disabled
                  value={editableData.name ? editableData.name : "Loading..."}
                />
              </Descriptions.Item>
              <Descriptions.Item label="EID">
                <Input value={editableData.eid} disabled />
              </Descriptions.Item>
              <Descriptions.Item label="Tanggal">
                <Input value={editableData.tgl} disabled />
              </Descriptions.Item>

              <Descriptions.Item label="Schedule">
                <Select
                  defaultValue={defaultSchedule?._id} // Menggunakan _id sebagai default value
                  value={
                    scheduleList.find(
                      (item) => item._id === editableData.schedule // Menemukan schedule berdasarkan _id
                    )?._id
                  }
                  onChange={(value) => handleChange("schedule", value)} // Mengubah nilai berdasarkan _id
                  style={{ width: "100%" }}
                >
                  {scheduleList.map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.code} ({item.timeIn} - {item.timeOut})
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>

              <Descriptions.Item label="Jam Masuk">
                <Input
                  value={editableData.in}
                  onChange={(e) => handleChange("in", e.target.value)}
                />
              </Descriptions.Item>
              {/* <Descriptions.Item label="Lokasi Masuk">
                <Input
                  value={editableData.location_in}
                  onChange={(e) => handleChange("location_in", e.target.value)}
                />
              </Descriptions.Item> */}
              <Descriptions.Item label="Lokasi Masuk">
                <Select
                  value={editableData.location_in}
                  onChange={(value) => handleChange("location_in", value)} // Handle location_in change
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Pilih lokasi masuk"
                  filterOption={
                    (
                      input,
                      option: any // Use 'any' here to allow string methods like toLowerCase
                    ) =>
                      option &&
                      typeof option.children === "string" &&
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase()) // Ensure option.children is string
                  }
                >
                  {branchLists.map((branch) => (
                    <Select.Option key={branch._id} value={branch._id}>
                      {branch.name}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label="Foto Masuk">
                {editableData.image_in ? (
                  <Image width={100} src={editableData.image_in} />
                ) : (
                  <>NO FOTO</>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="Pilih Tanggal Keluar">
                <DatePicker
                  value={
                    editableData.outDate ? moment(editableData.outDate) : null
                  } // Mengonversi ke moment jika ada tanggal keluar
                  onChange={(date) =>
                    handleChange(
                      "outDate",
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  } // Format ke string "YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Jam Keluar">
                <Input
                  value={editableData.out}
                  onChange={(e) => handleChange("out", e.target.value)}
                />
              </Descriptions.Item>
              {/* <Descriptions.Item label="Lokasi Keluar">
                <Input
                  value={editableData.location_out}
                  onChange={(e) => handleChange("location_out", e.target.value)}
                />
              </Descriptions.Item> */}
              <Descriptions.Item label="Lokasi Keluar">
                <Select
                  value={editableData.location_out}
                  onChange={(value) => handleChange("location_out", value)} // Handle location_out change
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Pilih lokasi keluar"
                  filterOption={
                    (
                      input,
                      option: any // Use 'any' here to allow string methods like toLowerCase
                    ) =>
                      option &&
                      typeof option.children === "string" &&
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase()) // Ensure option.children is string
                  }
                >
                  {branchLists.map((branch) => (
                    <Select.Option key={branch._id} value={branch._id}>
                      {branch.name}
                    </Select.Option>
                  ))}
                </Select>
              </Descriptions.Item>
              <Descriptions.Item label="Overtime">
                <Input
                  value={editableData.overtime}
                  onChange={(e) => handleChange("overtime", e.target.value)}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Approval Overtime">
                <Input
                  value={editableData.approval_overtime}
                  onChange={(e) =>
                    handleChange("approval_overtime", e.target.value)
                  }
                />
              </Descriptions.Item>
              <Descriptions.Item label="Catatan Overtime">
                <Input.TextArea
                  value={editableData.overtime_notes}
                  onChange={(e) =>
                    handleChange("overtime_notes", e.target.value)
                  }
                />
              </Descriptions.Item>
              <Descriptions.Item label="Total Jam Kerja">
                <Input value={editableData.work_hour} disabled />
              </Descriptions.Item>
              <Descriptions.Item label="Keterlambatan">
                <Input value={editableData.lates} disabled />
              </Descriptions.Item>
              <Descriptions.Item label="Status Request">
                <Input value={editableData.requestStatus} disabled />
              </Descriptions.Item>
            </Descriptions>

            <Button
              type="primary"
              onClick={handleSave}
              style={{ marginTop: 20 }}
              disabled={loading}
            >
              Simpan Perubahan
            </Button>
          </Form>
        </Card>
      ) : (
        <>Loading</>
      )}
    </>
  );
};

export default DetailAttendance;
